import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms'; // <-- NgModel lives here
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { KaizensComponent } from './kaizens/kaizens.component';
import { KaizenDetailComponent } from './kaizen-detail/kaizen-detail.component';
import { MessagesComponent } from './messages/messages.component';
import { AddEditKaizenComponent } from './add-edit-kaizen/add-edit-kaizen.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NavComponent } from './nav/nav.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule} from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import {MaterialExampleModule} from '../material.module';
import {VERSION as CDK_VERSION} from '@angular/cdk';
import {VERSION as MAT_VERSION} from '@angular/material/core';
import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import{MatProgressBarModule as MatProgressBarModule  } from '@angular/material/progress-bar';
//import{ MatProgressSpinner} from '@angular/material/progress-spinner';
import{ SpinnerComponent}  from './spinner/spinner.component';
import { CmdreviewComponent } from './cmdreview/cmdreview.component';
import { CmdreviewKaizendetailComponent } from './cmdreview-kaizendetail/cmdreview-kaizendetail.component';
import { DialogapproveconfirmComponent } from './dialogapproveconfirm/dialogapproveconfirm.component';
import { DialogrejectconfirmComponent } from './dialogrejectconfirm/dialogrejectconfirm.component';
import { MatDialogModule} from '@angular/material/dialog';
import { DialogcancelconfirmComponent } from './dialogcancelconfirm/dialogcancelconfirm.component';

import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { InteractionType, IPublicClientApplication, PublicClientApplication, } from '@azure/msal-browser';
import { environment } from '@environment/environment';
const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

import { DialogdeletekaizenconfirmComponent } from './dialogdeletekaizenconfirm/dialogdeletekaizenconfirm.component';
import { MyKaizensComponent } from './my-kaizens/my-kaizens.component';
import { UserprofileComponent } from './userprofile/userprofile.component';
import { ForecastadjustmentsComponent } from './forecastadjustments/forecastadjustments.component';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { DialogdelaccountComponent } from './dialogdelaccount/dialogdelaccount.component';
import { MultiaccountComponent } from './multiaccount/multiaccount.component';
import { ActualsComponent } from './actuals/actuals.component';
import { DialogDeleteAccountWithActualsConfirmComponent } from './dialogdeleteaccountwithactualsconfirm/dialogdeleteaccountwithactualsconfirm.component';
import { RankComponent } from './rank/rank.component';
import { RingiComponent } from './ringi/ringi.component';
import { ContactComponent } from './contact/contact.component';
import { LocationComponent } from './location/location.component';
import { DescriptionComponent } from './description/description.component';
import { AttachmentComponent } from './attachment/attachment.component';
import { YokotenComponent } from './yokoten/yokoten.component';
import { AccountstabComponent } from './accountstab/accountstab.component';
import { AdvancedsearchComponent } from './advancedsearch/advancedsearch.component';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId, // This is your client ID
       authority: 'https://login.microsoftonline.com/' + environment.tenantId, // 'Enter_the_Tenant_Info_Here', // This is your tenant ID
       redirectUri: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : ''),          
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true, // set to true for IE 11
    }    
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([        
      [environment.APIURL, [environment.apiScope]]
    ])
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: []
    }
  };
}

@NgModule({ declarations: [
        AppComponent,
        KaizensComponent,
        KaizenDetailComponent,
        MessagesComponent,
        AddEditKaizenComponent,
        NavComponent,
        SpinnerComponent,
        CmdreviewComponent,
        CmdreviewKaizendetailComponent,
        DialogapproveconfirmComponent,
        DialogrejectconfirmComponent,
        DialogcancelconfirmComponent,
        DialogdeletekaizenconfirmComponent,
        MyKaizensComponent,
        UserprofileComponent,
        ForecastadjustmentsComponent,
        DialogdelaccountComponent,
        MultiaccountComponent,
        ActualsComponent,
        DialogDeleteAccountWithActualsConfirmComponent,
        RankComponent,
        ContactComponent,
        LocationComponent,
        RingiComponent,
        DescriptionComponent,
        AttachmentComponent,
        YokotenComponent,
        AccountstabComponent,
        AdvancedsearchComponent
    ],
    exports: [
        MatDialogModule
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        FormsModule,
        LayoutModule,
        MatToolbarModule,
        MatButtonModule,
        MatSidenavModule,
        MaterialExampleModule,
        MatTooltipModule,
        MatIconModule,
        MatListModule,
        MatProgressBarModule,
        //MatProgressSpinner
        MatDialogModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useValue: {
                interactionType: InteractionType.Redirect,
                authRequest: {
                    scopes: []
                }
            } as MsalGuardConfiguration
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
